import { useState } from 'react';

type DeleteDialogState = {
  open: boolean;
  hotelId: string | null | undefined;
  hotelName: string;
};

type ViewMode = 'grid' | 'list' | 'table';

/**
 * Hook for managing UI state in hotel components
 */
export const useHotelUIState = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [deleteDialog, setDeleteDialog] = useState<DeleteDialogState>({
    open: false,
    hotelId: null,
    hotelName: '',
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [viewMode, setViewMode] = useState<ViewMode>('grid');

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleExpandClick = (id: string) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleDeleteClick = (hotelId: string | undefined, hotelName: string, event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation();
    }

    setDeleteDialog({
      open: true,
      hotelId,
      hotelName,
    });
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({
      open: false,
      hotelId: null,
      hotelName: '',
    });
  };

  const showSnackbar = (message: string) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  return {
    // Tab state
    tabValue,
    handleTabChange,
    setTabValue,

    // Edit state
    isEditing,
    setIsEditing,

    // Expansion state for accordion-like components
    expanded,
    handleExpandClick,

    // Delete dialog state
    deleteDialog,
    handleDeleteClick,
    closeDeleteDialog,

    // Snackbar notification state
    snackbarOpen,
    snackbarMessage,
    showSnackbar,
    closeSnackbar,

    // View mode for list views
    viewMode,
    setViewMode
  };
};